"use strict";

var $ = require("jquery");

$(document).ready(function () {
    var input_timer;  // timer identifier
    var vat_input = jQuery( 'input[name="billing_eu_vat_number"]' );

    vat_input.on( 'input', function() {
        clearTimeout( input_timer );
        input_timer = setTimeout( function() {
            jQuery( 'body' ).trigger( 'update_checkout' );
        }, 500 );
    } );
});

